import { FC, lazy } from 'react';

const PasswordForgottenPageDefaultView = lazy(
  () => import('./default-view/PasswordForgottenPageDefaultView'),
);

export const PasswordForgottenPage: FC = () => <PasswordForgottenPageDefaultView />;
